module.exports = __webpack_public_path__ + "static/img/3_1_9.4cf8405e.jpg";